import Pristine from 'pristinejs'

export default function form ($form, { success }) {
  let pristine = new Pristine(
    $form,
    {
      errorTextClass: 'text-red text-16 mt-5'
    },
    false
  )

  function onSubmit (e) {
    e.preventDefault()
    $form.querySelector('button[type="submit"]').disabled = true
    let isValid = pristine.validate()
    if (!isValid) {
      $form.querySelector('button[type="submit"]').disabled = false
      return
    }

    window
      .fetch($form.action, {
        method: $form.method || 'POST',
        body: new window.FormData($form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(res => res.json())
      .then(data => {
        if (data.success === true) {
          $form.parentNode.removeChild($form)
          document.getElementById(success).hidden = false
        } else {
          $form.querySelector('button[type="submit"]').disabled = false
        }
      })
  }

  $form.addEventListener('submit', onSubmit)

  return () => {
    $form.removeEventListener('submit', onSubmit)
    pristine.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/js/components/form.js